import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { invalidateTaskCounts } from '@/pages/authenticated/home/utils/invalidateTaskCounts';

const useDeleteSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  const queryClient = useQueryClient();

  return useMutationApi<void>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}`,
    method: 'DELETE',
    options: {
      onSuccess: () => {
        // Invalidate home page task counts
        invalidateTaskCounts(queryClient);
        // Call consumer's onSuccess callback
        onSuccess?.();
      },
    },
  });
};

export default useDeleteSalesOrderDraft;
